import { DataBean } from "../../DataBean";


export class HealthIDNoteCatalog extends DataBean {

    public async getHealthIDNoteCatalog(jsonCode: any, regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthIDNoteCatalog_String_String_Number_Number", [jsonCode, regexStr, page, recordsPerPage]);
    }

}